import React from 'react'
import PropTypes from 'prop-types'

import { Box, CTA, DesktopOnly, ReadMore, Responsive, P, UL } from 'ui/acro'

const Benefits = ({ benefits }) => {
  const benefitsList = () => (
    <UL>
      {benefits.map((benefit, idx) => (
        <P as='li' key={idx}>
          {benefit}
        </P>
      ))}
    </UL>
  )

  return (
    <Box mb={['23px', null, '38px']}>
      <CTA pb={['11px', null, '10px']} color='grey6'>
        Benefits
      </CTA>
      <DesktopOnly>{benefitsList()}</DesktopOnly>
      <Responsive show={[true, true, false]}>
        <ReadMore id='plan_benefits_readmore'>{benefitsList()}</ReadMore>
      </Responsive>
    </Box>
  )
}

Benefits.propTypes = {
  benefits: PropTypes.array
}

export default Benefits
